module.exports = __webpack_public_path__ + "img/clock.15cc431d.svg";